import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { IcebergIcon } from '@tradesolution/iceberg-ui-react';

import { CompareStatus } from '../../utils';

interface Props {
  compareStatus: CompareStatus;
  size?: 'xs' | 'sm' | 'lg' | '2x';
  onClick?: () => void;
  tooltipText?: string;
}

const CompareIcon = (props: Props) => {
  //Function to get tooltip text based on compare status
  const getTooltipText = () => {
    switch (props.compareStatus) {
      case 'ny':
        return 'Du kan overføre denne verdien. Ingen eksisterende verdi er til stede.'; //arrow-right icon green
      case 'ignorer':
        return 'Ingen verdi å overføre.'; //check icon grey
      case 'lik':
        return 'Verdiene er identiske. Ingen overføring er nødvendig.'; //check icon green
      case 'ulik':
        return 'Oops!... Verdiene er forskjellige; klikk for å overføre den nye verdien.'; //arrow-right icon orange
      case 'ugyldig':
        return 'Ugyldig verdi. Du kan ikke overføre denne verdien.'; // check icon grey
      default:
        return 'Ukjent status.';
    }
  };

  // Render the icon with tooltip
  const renderIcon = () => {
    switch (props.compareStatus) {
      case 'ny':
        return (
          <span onClick={props.onClick} style={{ cursor: 'pointer' }}>
            <IcebergIcon
              icon="arrow-right"
              backgroundColor="orange"
              color="#fff"
              size={props.size || ''}
              rounded
              bold
            />
          </span>
        );
      case 'ignorer':
        return (
          <div style={{ cursor: 'pointer' }}>
            <IcebergIcon
              icon="check"
              color="#fff"
              backgroundColor="grey"
              size={props.size || ''}
              rounded
              bold
            />
          </div>
        );
      case 'ugyldig':
        return (
          <div style={{ cursor: 'pointer' }}>
            <IcebergIcon
              icon="close"
              color="#fff"
              backgroundColor="grey"
              size={props.size || ''}
              rounded
              bold
            />
          </div>
        );
      case 'lik':
        return (
          <div style={{ cursor: 'pointer' }}>
            <IcebergIcon
              icon="check"
              size={props.size || ''}
              backgroundColor="green"
              color="#fff"
              rounded
              bold
            />
          </div>
        );
      case 'ulik':
        return (
          <div onClick={props.onClick} style={{ cursor: 'pointer' }}>
            <IcebergIcon
              icon="arrow-right"
              backgroundColor="orange"
              color="#fff"
              size={props.size || ''}
              rounded
              bold
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <OverlayTrigger
      key="tooltip-top"
      placement="top"
      overlay={<Tooltip id="tooltip">{props.tooltipText ?? getTooltipText()}</Tooltip>}
    >
      <div>{renderIcon()}</div>
    </OverlayTrigger>
  );
};

export default CompareIcon;
